import { render, staticRenderFns } from "./BaseShell.vue?vue&type=template&id=bd73e566&scoped=true"
import script from "./BaseShell.vue?vue&type=script&lang=js"
export * from "./BaseShell.vue?vue&type=script&lang=js"
import style0 from "./BaseShell.vue?vue&type=style&index=0&id=bd73e566&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd73e566",
  null
  
)

export default component.exports